import React from 'react';
import PropTypes from 'prop-types';
import { BlackBoxDeviceDetection } from '../../components/black-box-device-detection';
import { useBlackBoxDetection } from '../../hooks/use-black-box-detection';

/**
 * A wrapper component for BlackBoxDeviceDetection that handles conditional rendering
 * and provides consistent styling across different parts of the application.
 * @param {object} props - Component props
 * @param {(id: string, value: boolean) => void} props.updateRequirementStatus - Function to update requirement status
 * @returns {React.ReactElement|null} - Rendered component or null if not needed
 */
export const BlackBoxSection = ({ updateRequirementStatus }) => {
  const { blackBoxRequired, blackBoxAlreadyCollected, handleBlackBoxComplete } = useBlackBoxDetection(updateRequirementStatus);

  if (!blackBoxRequired || blackBoxAlreadyCollected) {
    return null;
  }
  return <BlackBoxDeviceDetection markFormComplete={handleBlackBoxComplete} />;
};

BlackBoxSection.propTypes = {
  updateRequirementStatus: PropTypes.func.isRequired,
};
